import React from 'react'
import { useSelector } from "react-redux"
import { Link } from 'react-router-dom'
import { Container, Button } from "react-bootstrap"
import { RootState } from '../store/store'
import { useTranslation } from 'react-i18next';
import { Offer } from '../types/offerForm'
import OfferList from '../components/OfferList'



const OfferPage: React.FC = () => {
  const { t } = useTranslation();  
  const offers = useSelector((state: RootState) => state.offers as Offer[])
  return (
    <div className="d-flex flex-column align-items-center w-100">
      <Container className="mt-5 mb-5">
        <div className='d-flex justify-content-between'>
          <div className='mb-3'>
            <h1>{t('offers')}</h1>
            <span>{t('totalOffers')}: {offers?.length}</span>
          </div>
          <div className='mb-2'>
            <Link to="/create" state={{ type: 'offer' }}>
              <Button variant="primary" size="sm">
                + {t('createOffer')}
              </Button>
            </Link>{' '}
          </div>
        </div>
        <OfferList offers={offers} />
      </Container>
    </div>
  )
}

export default OfferPage
